import { getData, putData } from 'src/api/http.service';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';
import {
  getAPIEndpoints,
  handleApiSuccess,
  handleApiError,
  getDataFromSessionStorage,
} from 'src/utils';

const hallTicketsActionTypes = {
  GET_ALL_STUDENTS_HALL_TICKETS: 'GET_ALL_STUDENTS_HALL_TICKETS',
};

let studentHallTicketsRequestId = 0;

const getStudentHallTickets = ({
  page = 0,
  size = 10,
  sort = 'DESC',
  sortBy = 'updatedAt',
  startDate,
  endDate,
  search,
  status,
} = {}) => async dispatch => {
  const requestId = ++studentHallTicketsRequestId;
  dispatch(ApiCallInProgress());
  try {
    const updatedAtDateParams =
      startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : '';
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    const statusParam = status ? `&status=${status}` : '';
    const response = await getData(
      `${
        getAPIEndpoints().hallTickets
      }?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}${updatedAtDateParams}${searchParam}${statusParam}`
    );
    if (requestId !== studentHallTicketsRequestId) return;
    dispatch({
      type: hallTicketsActionTypes.GET_ALL_STUDENTS_HALL_TICKETS,
      payload: response.data,
    });
    dispatch(ApiCallSuccessAction({ message: '' }));
  } catch (err) {
    if (requestId !== studentHallTicketsRequestId) return;
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};

const hallTicketDocumentVerification = body => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await putData(`${getAPIEndpoints().hallTickets}`, body, {
      userId: getDataFromSessionStorage('userInfo')?.userId,
    });

    let formattedResponse = handleApiSuccess(response);
    dispatch(ApiCallSuccessAction(formattedResponse));
    return formattedResponse;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return false;
  }
};

export { hallTicketsActionTypes, getStudentHallTickets, hallTicketDocumentVerification };
